import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyExportRequestBody, PropertyExportResponse } from "./types";

export class PropertyExportAPI extends BaseAPI<
    PropertyExportRequestBody,
    PropertyExportResponse
> {
    protected route = ApiRoutes.property.export;
    protected method = RequestMethod.GET;
    protected params = ["search", "status", "type", "is_hot"];
} 